import { Typography, Box } from '@mui/material'
import * as React from 'react'
import { JobT } from '../../../../../types/Job'

import Estimates from './Estimates'

import PackingMaterials from './PackingMaterials'
import Valuation from './Valuation'
import { DocumentT } from '../../../../../types/Job'
import { getVariableValue, setValueVariables, VariableDocumentT } from '../DocumentVariables'
import { convertArrayToObject, copyObject } from '../../../../../utils'
import _, { merge } from 'lodash'
import { getVariablesForDocument, getDocumentValue } from '../DocumentsUtils'
import PackingMaterialsList, { getDefaultPackingMaterials } from '../../../../Settings/PackingMaterialsList'
import { PackingMaterialsLineItemT, PackingMaterialsValueObj } from '../../../../../types/PackingMaterialsT'
import { useImmer } from 'use-immer'
import moment from 'moment'
import { useMemoCompare } from '../../../../../utils/hooks'


interface BillOfLadingT extends DocumentT { }
const BillOfLadingObj: BillOfLadingT = {
    active: true,
    title: 'Bill Of Lading',
    name: 'billOfLading',
    variables: [
        {
            key: "optionEstimate",
            type: "string",
            value: null,
        },

        {
            key: "optionValuation",
            type: "string",
            value: null,
        },
        {
            key: "packingMaterials",
            type: "array",
            value: [],
        }
    ]

}

const generateDefaultVariables = (): Array<VariableDocumentT> => {
    let variables = copyObject(BillOfLadingObj.variables)
    let defaultPackingMaterials = getDefaultPackingMaterials()
    variables = setValueVariables("packingMaterials", defaultPackingMaterials, variables, BillOfLadingObj.variables, "array")
    return variables
}



const getDefaultBillOfLading = () => {

}


interface BillOfLadingProps {
    job: JobT
    updateDocument(key: string, value: any): void
    isActive: boolean
    jobOrigin: JobT

}

const initVariablesBillOfLading =
{
    optionEstimate: null,
    optionValuation: null,
    packingMaterials: []

}


const BillOfLading: React.FunctionComponent<BillOfLadingProps> = (props): JSX.Element => {

    const [currentVariables, setCurrentVariables] = React.useState(BillOfLadingObj.variables)
    const [packingMaterials, setPackingMaterials] = React.useState([]);
    const [requestEstimateOfShipment, setRequestEstimateOfShipment] = React.useState(null);
    const [currentDocument, setCurrentDocument] = React.useState(copyObject(BillOfLadingObj));

    const defaultPackingMaterials = getDefaultPackingMaterials()
    const [companyPackingMaterials, setCompanyPackingMaterials] = React.useState(defaultPackingMaterials)
    const [variablesBillOfLading, setVariablesBillOfLading] = useImmer(initVariablesBillOfLading);
    const defaultVariables = generateDefaultVariables()
    const [isReady, setIsReady] = React.useState(false);
    const [locations, setLocations] = React.useState([]);
    const [addressState, setAddressState] = React.useState("");
    const [jobType, setJobType] = React.useState("");

    const jobFinal = useMemoCompare(props.jobOrigin, (prev, next) => {
        return prev && prev.documents === next.documents;
    });

    React.useEffect(() => {
        let cloneCurrentDocument = copyObject(currentDocument)
        let defaultVariables = generateDefaultVariables()
        let variables = getVariablesForDocument(jobFinal, "billOfLading", copyObject(cloneCurrentDocument.variables))
        cloneCurrentDocument.variables =_.uniq(_.merge(defaultVariables, variables))
        setCurrentDocument(cloneCurrentDocument)
        setIsReady(true)
    }, []);



    React.useEffect(() => {
        if (props.job.jobType != jobType) {
            setJobType(props.job.jobType)
        }
    }, [props.job.jobType])

    React.useEffect(() => {
        if (!_.isEqual(props.job.locations, props.job.locations)) {
            if (_.isArray(props.job.locations) && props.job.locations.length > 0) {
                setAddressState(props.job.locations[0].addressState)
            }
            setLocations(props.job.locations)
        }
    }, [props.job.locations])


    React.useEffect(() => {
        if (isReady) {
            let cloneDocument = getDocumentValue(jobFinal, "billOfLading", copyObject(BillOfLadingObj))

            if (!_.isEqual(cloneDocument, currentDocument)) {
                let cloneCurrentDocument = copyObject(cloneDocument)
                let defaultVariables = generateDefaultVariables()
                let variables = getVariablesForDocument(jobFinal, "billOfLading", copyObject(cloneDocument.variables))
                // @ts-ignore
                cloneCurrentDocument.variables = _.uniqBy(_.merge(defaultVariables, variables),"key")

                // setVariables(cloneCurrentDocument.variables)
                updateVariablesBillOfLadin(cloneCurrentDocument.variables)
                setCurrentDocument(cloneCurrentDocument)
            }

        }

    }, [jobFinal, isReady]);






    const updateVariables = (key: string, value: any, typeVariable: string): void => {


        onChangeVariablesBillOfLadin(key, value)
        let previousVariables = copyObject(currentDocument.variables)
        let cloneVariables = setValueVariables(key, value, previousVariables, copyObject(BillOfLadingObj.variables), typeVariable)

        const newVariables = copyObject(cloneVariables)
        applyChangeVariables(newVariables)
    }

    /**
     *
     * @param _variables
     * @param key
     * @param value
     */

    const onChangeVariablesBillOfLadin = (key: string, value: any,) => {
        // let newVariables = copyObject(variablesBillOfLading)
        // newVariables[key] = value
        setVariablesBillOfLading((draft) => {
            draft[key] = value
        })
        // setVariablesBillOfLading(newVariables)
    }


    const updateVariablesBillOfLadin = (_variables) => {
        let newVariables = Object.assign({}, initVariablesBillOfLading)
        Object.keys(variablesBillOfLading).map((key, index) => {
            newVariables[key] = getVariableValue(key, copyObject(_variables), null)
        })

        setVariablesBillOfLading(newVariables as any)
    }


    const applyChangeVariables = (_variables: Array<VariableDocumentT>) => {
        let documentBillOfLading = copyObject(currentDocument)
        documentBillOfLading.variables = _variables
        setCurrentDocument(documentBillOfLading)
        props.updateDocument('billOfLading', documentBillOfLading)
    }


    if (!props.isActive) {
        return null
    }

    return (
        <Box>
            <Typography variant="h4">Bill Of Lading</Typography>
            <Estimates
                jobType={jobType}
                addressState={addressState}
                value={variablesBillOfLading.optionEstimate}
                updateValue={(value) => {
                    updateVariables("optionEstimate", value, "string")
                }}
            />
            <Valuation
                value={variablesBillOfLading.optionValuation}
                updateValue={(value) => {
                    updateVariables("optionValuation", value, "string")
                }}
            />
            <PackingMaterials
                job={props.jobOrigin}
                value={variablesBillOfLading.packingMaterials}
                updateValue={(items) => {
                    updateVariables("packingMaterials", items, "array")
                }} />
        </Box>
    )
}

export default BillOfLading
